import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

/* Déplie temporairement les conteneurs à défilement (tableaux, listes) pour capturer leur contenu complet. */
function expandScrollables(root) {
  const touched = [];
  root.querySelectorAll("*").forEach(el => {
    const cs = getComputedStyle(el);
    const scrollY = /(auto|scroll)/.test(cs.overflowY) && el.scrollHeight > el.clientHeight + 2;
    const scrollX = /(auto|scroll)/.test(cs.overflowX) && el.scrollWidth > el.clientWidth + 2;
    if (!scrollY && !scrollX) return;
    touched.push([el, el.getAttribute("style")]);
    el.style.overflow = "visible"; el.style.maxHeight = "none"; el.style.height = "auto";
    if (scrollX) el.style.width = `${el.scrollWidth}px`;
  });
  return () => touched.forEach(([el, st]) => st === null ? el.removeAttribute("style") : el.setAttribute("style", st));
}

/* Capture complète d'un élément (ou de <main>) → PDF A4 paysage multi-pages avec en-tête (titre, filtres, date). */
export async function exportPagePdf({ title, filters = "", element, filename } = {}) {
  const root = element || document.querySelector("main") || document.body;
  const restore = expandScrollables(root);
  root.classList.add("pdf-capturing");
  await new Promise(r => setTimeout(r, 150));
  let canvas;
  try {
    canvas = await html2canvas(root, { scale: 1.5, useCORS: true, backgroundColor: "#f8fafc", logging: false, windowWidth: Math.max(root.scrollWidth, 1280), width: Math.max(root.scrollWidth, 1280), height: root.scrollHeight, scrollX: 0, scrollY: -window.scrollY });
  } finally { root.classList.remove("pdf-capturing"); restore(); }
  const pdf = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const W = pdf.internal.pageSize.getWidth(), H = pdf.internal.pageSize.getHeight(), M = 8, HEAD = 14;
  const imgW = W - 2 * M, pxPerMm = canvas.width / imgW, sliceH = Math.floor((H - HEAD - M) * pxPerMm);
  const date = new Date().toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  const pages = Math.max(1, Math.ceil(canvas.height / sliceH));
  for (let p = 0; p < pages; p++) {
    if (p) pdf.addPage();
    pdf.setFillColor(15, 31, 61); pdf.rect(0, 0, W, HEAD - 3, "F");
    pdf.setTextColor(255, 255, 255); pdf.setFontSize(11); pdf.setFont(undefined, "bold"); pdf.text(String(title || document.title || "Orbit"), M, 7.5);
    pdf.setFontSize(7.5); pdf.setFont(undefined, "normal"); pdf.text(`${filters ? filters + "  ·  " : ""}Export ${date}  ·  page ${p + 1}/${pages}`, W - M, 7.5, { align: "right" });
    const part = document.createElement("canvas"); part.width = canvas.width; part.height = Math.min(sliceH, canvas.height - p * sliceH);
    part.getContext("2d").drawImage(canvas, 0, p * sliceH, canvas.width, part.height, 0, 0, canvas.width, part.height);
    pdf.addImage(part.toDataURL("image/jpeg", 0.85), "JPEG", M, HEAD, imgW, part.height / pxPerMm);
  }
  pdf.save(filename || `${(title || "orbit").toLowerCase().replace(/[^a-z0-9]+/g, "-")}-${new Date().toISOString().slice(0, 10)}.pdf`);
}
